import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { interval } from 'rxjs';

import { BaseComponent } from '../../../core/abstractions/base.component';
import { VoteOptionEnum } from '../../../models/enums/vote-option.enum';
import { SimpleItemModel } from '../../../models/simple-item.model';
import { VotingMonitorItemModel } from '../../../models/voting-monitor-item.model';
import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';

@Component({
    selector: 'sl-voting-monitor',
    templateUrl: './voting-monitor.component.html',
    styleUrls: ['./voting-monitor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VotingMonitorComponent extends BaseComponent implements OnInit {
    VoteOptionEnum = VoteOptionEnum;
    currentVoting: VotingMonitorItemModel[] = [];
    agendaItems: SimpleItemModel[] = [];
    currentItemNumber?: any;

    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    ngOnInit(): void {
        const updateVotingInterval = interval(1000); // Every second we check if the list has changed.
        const updateVotingSub = updateVotingInterval.subscribe(() => {
            this.loadAgendaItems();

            if (!!this.currentItemNumber) {
                this.loadVoting();
            }
        });

        this.loadAgendaItems();
        this.addSubscriptions(updateVotingSub);
    }

    selectItem(event?: MatAutocompleteSelectedEvent): void {
        if (!!event && !event.option) {
            return;
        }

        this.currentItemNumber = !!event ? +event.option.id : undefined;
        this.loadVoting();
    }

    private loadAgendaItems(): void {
        this.agendaItems = [];
        this.generalMeetingsResource.getCurrentAgendaItemsForShareholder().subscribe(r =>
            r.value
                .filter(i => i.isVotingOpen)
                .forEach(i => {
                    this.agendaItems.push(
                        new SimpleItemModel({
                            id: i.gmAgendaItemNumber.toString(),
                            label: i.description
                        })
                    );

                    // eslint-disable-next-line eqeqeq
                    if (!this.currentItemNumber || !this.agendaItems.find(ai => ai.id == this.currentItemNumber)) {
                        this.currentItemNumber = this.agendaItems[0].id;
                    }
                })
        );
    }

    private loadVoting(): void {
        if (!this.currentItemNumber) {
            this.currentVoting = [];
            return;
        }

        this.generalMeetingsResource.votingMonitor(this.currentItemNumber).subscribe(r => {
            // This is required because we may have removed the selection while the request was being done.
            if (!!this.currentItemNumber) {
                this.currentVoting = r.value;
            }
        });
    }
}
